import { service } from '../../../../helpers/http' 

export const ActionGetGroupSubscribers = ({ dispatch }, payload) => { 
    return service({
        module: 'domainGroupSubscriber',
        action: 'getGroupSubscribers',
        payload: payload
    })
}

export const ActionPostGroupSubscribers = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupSubscriber',
        action: 'postGroupSubscribers',
        payload: payload
    })
    
}

export const ActionPutGroupSubscribers = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupSubscriber',
        action: 'putGroupSubscribers',
        payload: payload
    })
    
}

export const ActionDeleteGroupSubscribers = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupSubscriber',
        action: 'deleteGroupSubscribers',
        payload: payload
    })
    
}
